async function getListGenre(name) {
  const params = {
    name: name,
  };
  const queryParams = new URLSearchParams(params);

  return fetch('/api/genre?' + queryParams
  ).then(res => {
    return res;
  })
  .catch(errors => {
    return errors;
  })
}

async function getGenres(param) {
  const queryParams = new URLSearchParams(param);

  return fetch(`/api/genres/list-of-category?${queryParams}`
  ).then(res => {
    return res;
  })
  .catch(errors => {
    return errors;
  })
}

async function countFromGenre(param, api) {
  const queryParams = new URLSearchParams(param);
  return fetch(`${api}?${queryParams}`
  ).then(res => {
    return res;
  })
  .catch(errors => {
    return errors;
  })
}

export { getListGenre, getGenres, countFromGenre }
